import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request, {
  isSalesManager,
  canSubmitOrders
} from '../../utils/request';
import Locked from './Locked';
import ViewOrder from './viewOrder';
import DownloadQuotePdf from './downloadQuotePdf';

import { actionsRest } from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const { isLockedBy } = order;
  const { email } = request.getProfile();

  // SOF-3356 Phase 9 T058 — defence-in-depth UX lock for the BCx Sales Rep
  // dashboard ("My Orders" tile). Side-effect of T054: SMs without
  // `canSubmitOrders` can now reach this listing and may have historical
  // own-submitted orders, reporting reps' orders, or dealership-wide rows
  // visible. Per stakeholder feedback (2026-05-05), every mutating
  // affordance (ModifyQuote, ProceedWithOrder, CancelOrder, RequestOrderReturn,
  // RequestContractResend) MUST be suppressed for these users on EVERY row
  // regardless of status / lock state — only ViewOrder + DownloadQuotePdf
  // (read-only export) remain. Backend FR-B024 mutation gate is the
  // authoritative boundary; this is UI hygiene to keep the user out of
  // dead-end flows.
  const rowActions = _.get(actionsRest, status, []);
  const filteredActions =
    isSalesManager && !canSubmitOrders()
      ? rowActions.filter(Action => Action === ViewOrder || Action === DownloadQuotePdf)
      : rowActions;

  return (
    <div className="responsive-table__actions">
      {isLockedBy && isLockedBy !== email ? (
        <Locked />
      ) : (
        filteredActions.map(Action => (
          <Action status={status} orderData={order} fetchOrders={fetchOrders} />
        ))
      )}
    </div>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
